export enum SystemRoleIds {
  CompanyAdminRoleId = 5,
  StoreManagerId = 13,
  StoreManagerLimitedId = 147,
  DefaultCompanyApikeyRole = 346
}
